import request from "@/router/axios";
export const list = () => {
  return request({
    url: `/api/zl/project/list`,
    method: "post",
    data: {
      orderBy: "id",
      isDesc: false,
    },
  });
};
export const projectParts = (projectId) => {
  return request({
    url: `/api/zl/part/list`,
    method: "post",
    data: {
      filterParams: [{ name: "projectId", value: projectId }],
      orderBy: "id",
      isDesc: false,
    },
  });
};
export const listByHos = (hosId) => {
  return request({
    url: `/api/zl/project/list`,
    method: "post",
    data: {
      filterParams: [{ name: "hosId", value: hosId }],
      orderBy: "id",
      isDesc: false,
    },
  });
};
export const getHosProjects = (hosId) => {
  return request({
    url: `/api/zl/project/list`,
    method: "post",
    data: {
      filterParams: [{ name: "hosId", value: hosId }],
      orderBy: "id",
      isDesc: false,
    },
  });
};
export const editProject = (data) => {
  return request({
    url: `/api/zl/project/edit`,
    method: "post",
    data: data,
  });
};
export const editPart = (data) => {
  return request({
    url: `/api/zl/part/edit`,
    method: "post",
    data: data,
  });
};
export const saveMergeParts = (data) => {
  return request({
    url: `/api/zl/project/saveMergeParts`,
    method: "post",
    data: data,
  });
};
export const saveProjectTag = (projectIds, tagCodes) => {
  return request({
    url: `/api/zl/project/setProjectTag`,
    method: "post",
    params: {
      projectIds,
      tagCodes,
    },
  });
};
